export class FindingExclusionScopeFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<FindingExclusionScope>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<FindingExclusionScope>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FindingExclusionScopeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
